import React, { Component } from 'react';
import PackageFilter2 from './PackageFilter2';




function NumberSelected(number) {
  if (number.number > 0) {
     return (<span className="selection-indicator">{number.number} selected</span>)
  }
  return null;
}
export class PackageFilters extends Component {
  // getFiltersApiString = () => {
  //   return apiString + this.props.filterGroup.taxonomy
  // }

  // getFilters = () => {
  //   axios
  //     .get(this.getFiltersApiString())
  //     .then((res) => this.setState({ packageFilters: res.data }))
  // }


  filterPackages = (value, checked) => {
    console.log('filterPackages checked', value, checked);

    this.props.filterPackages(value, this.props.filterGroup.taxonomy)
  }


  render() {
    // console.log('this.state.packageFilters', this.state.packageFilters)
    // console.log('this.props.filterGroup', this.props.filterGroup)

    return (
      <div>
        <button className="btn btn-sidebar collapsed" type="button" data-bs-toggle="collapse" data-bs-target={"#" + this.props.filterGroup.taxonomy} aria-expanded="false" aria-controls={this.props.filterGroup.taxonomy}>
          {this.props.filterGroup.label}
          <NumberSelected number={this.props.numberChecked} />
          {/* <span className="selection-indicator">{this.state.numberChecked} selected</span> */}
        </button>
        <div className="collapse" id={this.props.filterGroup.taxonomy}>
            {this.props.filterGroup.filters.map((packageFilter) => (
            <PackageFilter2 
            key={packageFilter.slug} 
            packageFilter={packageFilter} 
            // selectedFilters={this.props.filterGroup.filters}
            filterPackages={this.filterPackages} />
        ))}
        </div>
      </div>
    )
  }
}

export default PackageFilters